/* @sravni/react-design-system version 0.2.50 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Space/index.js';
import modules_0b64ef5e from '../styles/Sheet.module.less.js';
import Space from '../../Space/src/Space.js';

/**
 * @description Sheet Footer component.
 *
 * @component
 * @example
 * ```jsx
 * <Sheet.Footer>content</Sheet>
 * ```
 */
var Footer = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, restProps = __rest(props, ["className", "children"]);
    var cx = useStyles(modules_0b64ef5e);
    return (React.createElement(Space, __assign({ ref: ref, size: 12, justify: "stretch", className: cx(className, 'footer') }, restProps), children));
});
Footer.defaultProps = {};

export default Footer;
//# sourceMappingURL=Footer.js.map
